module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1015-a9deb9fb2a517394c3aeda023c9adbf4.png";